import { useContext } from "react";
import { AuthContext } from "../../../util/context";
import CreateClient from "../../clients/create client/CreateClient";
import Login from "../../auth/Login";
import Dashboard from "../../dashboard/Dashboard";

export default function CreateClientPage() {
  let view;
  const { isAuthenticated, user, isUser } = useContext(AuthContext);

  const viewClient =
    user?.job_role?.toLowerCase() === "hr" ||
    user?.job_role?.toLowerCase() === "accountant" ||
    user?.job_role?.toLowerCase() === "hop" ||
    user?.job_role?.toLowerCase().includes("hod") ||
    user?.job_role?.toLowerCase() === "seed";

  if (viewClient) {
    view = <CreateClient />;
  } else {
    view = <Dashboard />;
  }
  return <>{isAuthenticated && isUser ? view : <Login />}</>;
}
